<template>
    <div>
        <el-table :data="list" style="width: 100%" v-loading="loading" @sort-change="handleSortChange"
                  resizable border stripe>
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column v-for="column in columns" :prop="column.prop" :label="column.label"
                             :width="column.width" :show-overflow-tooltip="true" :formatter="column.formatter"
                             :column-key="column.key" :sortable="'custom'">
                <template slot="header" slot-scope="scope">
                    {{scope.column.label}}
                    <i class="el-icon-arrow-down" slot="reference" @click.stop="handleFilterClick(column.prop)"></i>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="handleDeleteClick(scope.$index)" type="text" size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
                       :page-sizes="[10, 20, 30, 50]" :page-size="10" style="margin-top: 16px;"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        <el-dialog title="搜索" :visible.sync="dictionarySearchPanel.show" width="250px">
            <el-form size="small">
                <el-form-item>
                    <label>输入关键字以进行过滤：</label>
                </el-form-item>
                <el-form-item>
                    <el-select multiple placeholder="请选择" :filterable="true" remote
                               :remote-method="getHandleSelectTextChangeFunction(dictionarySearchPanel.prop)"
                               v-model="dictionarySearchPanel.value">
                        <el-option v-for="item in dictionarySearchPanel.options" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-search" @click="handleSearchClick(dictionarySearchPanel.prop)">
                    搜索
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="搜索" :visible.sync="datetimeSearchPanel.show" width="440px">
            <el-form size="small">
                <el-form-item>
                    <el-date-picker v-model="datetimeSearchPanel.value" type="datetimerange"
                                    range-separator="至" align="center"
                                    start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-search"
                           @click="handleSearchClick(datetimeSearchPanel.prop)">搜索
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="搜索" :visible.sync="numberSearchPanel.show" width="300px">
            <el-form size="small">
                <el-form-item>
                    <el-input type="number" v-model="numberSearchPanel.value[0]"
                              placeholder="请输入最小值"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input type="number" v-model="numberSearchPanel.value[1]"
                              placeholder="请输入最大值"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-search" @click="handleSearchClick(numberSearchPanel.prop)">
                    搜索
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="搜索" :visible.sync="textSearchPanel.show" width="250px">
            <el-form size="small">
                <el-form-item>
                    <label>输入关键字以进行过滤：</label>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="textSearchPanel.mode" placeholder="请选择匹配方式">
                        <el-option label="包含" value="1"></el-option>
                        <el-option label="等于" value="2"></el-option>
                        <el-option label="开始以" value="3"></el-option>
                        <el-option label="结束以" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="textSearchPanel.value"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-search" @click="handleSearchClick(textSearchPanel.prop)">
                    搜索
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import fieldDescriptionService from "../../../service/fieldDescriptionService";
    import dataService from "../../../service/dynamicentity/dataService";
    import moment from "moment";

    export default {
        async mounted() {
            await this.getColumns();
            await this.getList();
        },
        data() {
            return {
                columns: [],
                list: [],
                total: 0,
                pageSize: 10,
                pageIndex: 1,
                loading: false,
                sort: {prop: 'createTime', order: 'descending'},
                dictionary: {},
                textSearchPanel: {
                    show: false,
                    value: null,
                    prop: null,
                    mode: '1'
                },
                dictionarySearchPanel: {
                    show: false,
                    value: [],
                    prop: null,
                    options: []
                },
                numberSearchPanel: {
                    show: false,
                    value: [],
                    prop: null
                },
                datetimeSearchPanel: {
                    show: false,
                    value: [],
                    prop: null
                }
            };
        },
        methods: {
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getList();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getList();
            },
            handleSortChange(val) {
                if (val.prop) {
                    this.sort.prop = val.prop;
                    this.sort.order = val.order;
                } else {
                    // 当用户取消排序条件时，使用默认的创建时间倒序排序
                    this.sort.prop = 'createTime';
                    this.sort.order = 'descending';
                }
                this.getList();
            },
            /**
             * 高阶函数
             * 根据字段名返回各 Select 组件文本改变事件的处理函数
             **/
            getHandleSelectTextChangeFunction(prop) {
                let that = this;
                return async function (query) {
                    let resp = await dataService.getDictionary("1", prop, query, 1);
                    that.dictionarySearchPanel.options = Object.keys(resp.data.Data).map(value => ({
                        label: resp.data.Data[value],
                        value
                    }));
                }
            },
            handleFilterClick(prop) {
                let column = this.columns.filter(column => column.prop === prop)[0];
                let searchPanel = this.getSearchPanel(column.type);
                searchPanel.show = true;
                searchPanel.value = column.filter.value;
                searchPanel.prop = prop;
                searchPanel.mode = column.filter.mode;
            },
            getSearchPanel(type) {
                switch (type) {
                    case 2:
                        return this.numberSearchPanel;
                    case 4:
                        return this.datetimeSearchPanel;
                    case 6:
                    case 8:
                        return this.dictionarySearchPanel;
                    default:
                        return this.textSearchPanel;
                }
            },
            async handleSearchClick(prop) {
                let column = this.columns.filter(column => column.prop === prop)[0];
                let searchPanel = this.getSearchPanel(column.type);
                searchPanel.show = false;
                column.filter.value = searchPanel.value;
                // 字典类型面板清空字典项释放内存
                if (column.type === 6 || column.type === 8) {
                    this.dictionarySearchPanel.options = [];
                }
                await this.getList(this.getConditions());
            },
            getConditions() {
                let txtConditionGroups = this.getColumnsWillSearch(0).map(column => {
                    let value = null;
                    if (column.filter.mode === '2') {
                        value = column.filter.value;
                    } else if (column.filter.mode === '3') {
                        value = '%' + column.filter.value;
                    } else if (column.filter.mode === '4') {
                        value = column.filter.value + '%';
                    } else {
                        value = '%' + column.filter.value + '%';
                    }
                    return {
                        conditions: [{
                            field: column.prop,
                            operator: column.mode === 2 ? 10 : 38,
                            value: value
                        }]
                    };
                });

                let defaultFormat = 'YYYY-MM-DD HH:mm';
                let dtConditionGroups = this.getColumnsWillSearch(4).map(col => ({
                    conditions: [{
                        field: col.prop,
                        operator: 39,
                        value: col.filter.value.map(val => val ? moment(new Date(val)).format(defaultFormat) : null)
                    }]
                }));

                let numConditionGroups = this.getColumnsWillSearch(2).map(col => ({
                    conditions: [{
                        field: col.prop,
                        operator: 39,
                        value: col.filter.value.map(num => num || null)
                    }]
                }));

                let dictConditionGroups = [...this.getColumnsWillSearch(6), ...this.getColumnsWillSearch(8)].map(col =>
                    col.filter.value.map(id => ({
                        field: col.prop,
                        operator: 40,
                        value: id
                    }))).map(item => ({
                    conditions: item
                }));

                return [...dictConditionGroups, ...txtConditionGroups, ...dtConditionGroups, ...numConditionGroups];
            },
            getColumnsWillSearch(type) {
                if (type === 0 || type === 6 || type === 8) {
                    return this.columns.filter(column => {
                        return column.type === type ? column.filter.value : false;
                    });
                } else if (type === 2 || type === 4) {
                    return this.columns.filter(column => {
                        return column.type === type ? column.filter.value[0] || column.filter.value[1] : false;
                    });
                }
            },
            handleDeleteClick() {

            },
            async getColumns() {
                let resp = await fieldDescriptionService.getListDescription("3");
                if (resp.data.Status !== "1") {
                    return;
                }

                this.columns = resp.data.Data.map(desc => this.convertFieldDescriptionToColumn(desc));
            },
            async getList(conditionGroups) {
                this.loading = true;
                let listResp = await dataService.getList("3", this.sort, this.pageIndex, this.pageSize, 1, conditionGroups || []);
                this.loading = false;
                if (listResp.data.Status === "1") {
                    this.list = listResp.data.Data.data;
                    this.dictionary = listResp.data.Data.dictionary;
                    this.total = listResp.data.Data.total;
                }
            },
            convertFieldDescriptionToColumn(desc) {
                let that = this;
                return new function () {
                    this.prop = desc.fieldName;
                    this.label = desc.fieldShowName;
                    this.type = desc.inputType;
                    this.dictionary = desc.dictionary;
                    this.key = desc.uuid;
                    this.width = desc.width || 160;
                    this.format = desc.format;
                    let defaultFilterValue = null;
                    if (this.type === 2) {// 数字的默认值为数组
                        // 数字结构为 [min, max]，作为区间查询的条件
                        defaultFilterValue = [null, null];
                    } else if (this.type === 4) {// 时间的默认值为数组
                        // 时间的结构为 [min, max]，作为区间查询的条件
                        defaultFilterValue = ['', ''];
                    } else if (this.type === 6 || this.type === 8) {// 单选、多选多选的默认值为 []
                        // 字段中包含该数组的任一项即符合查询条件，如选择 [1, 2]，字段值为 1、1,2, 1,2,3 的数据均满足条件
                        defaultFilterValue = [];
                    } else {
                        defaultFilterValue = '';
                    }
                    this.filter = {mode: '1', value: defaultFilterValue};
                    let column = this;
                    this.formatter = function (row, elColumn, cellValue) {
                        if (column.type === 6 || column.type === 8) {
                            return that.getText(that.dictionary, column.dictionary, cellValue);
                        } else if (column.type === 4) {
                            if (cellValue) {
                                return moment(cellValue).format(column.format || 'YYYY-MM-DD HH:mm');
                            } else {
                                return '';
                            }
                        }
                        return cellValue;
                    }
                }();
            },
            getText(dictionary, dictionaryName, commaSplitValues) {
                if (!commaSplitValues || !dictionary[dictionaryName]) {
                    return '';
                }
                return commaSplitValues.split(',').map(value => dictionary[dictionaryName][value] || '')
                    .filter(text => text).join('，');
            }
        }
    };
</script>